var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('painel-erros-dotacoes',{attrs:{"dotacoes":_vm.despViagens ? _vm.despViagens.rateiosDespViagens : []}}),_c('desp-viagens',{attrs:{"despViagens":_vm.despViagens ? _vm.despViagens.despViagens : [],"movimentosServicos":_vm.movimentosServicos,"mostrarAcoes":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }